export {HighlightGeneral} from './lib/highlight-general';